import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import logo from '../asset/bg.jpg'
import logo22 from '../asset/ezgif-14755f8fd0bd20bd.gif.mp4'
import { 
  Award, 
  Users, 
  Clock, 
  Heart,
  CheckCircle,
  Star,
  Microscope,
  Shield
} from 'lucide-react';

const About = () => {
 



 

 

  return (
    <div className="min-h-screen">
   <Helmet>
  <title>About Us — YS Sky Travel and Tour Agency P.L.C</title>
  <meta name="description" content="Learn about YS Sky Travel and Tour Agency P.L.C, our mission, our team, and our vision." />
</Helmet>

      <div className="absolute top-0 left-0 w-full h-32 pointer-events-none 
                      bg-gradient-to-b from-white/80 to-transparent 
                      dark:from-black/80 z-10"></div>

      {/* Hero Section */}
      <section className="relative h-96 bg-gradient-to-r from-primary-900 via-primary-600 to-medical-600 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src={logo}
            alt="About us"
            className="w-full h-full object-cover opacity-30"
          />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center">
          <motion.div 
            className="text-center w-full"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
             About Us
            </h1>
            <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed">
             Leading Travel Agency
            </p>
          </motion.div>
        </div>

        {/* Animated Elements */}
        <div className="absolute top-20 right-20 w-32 h-32 bg-white/10 rounded-full animate-float"></div>
        <div className="absolute bottom-20 left-20 w-24 h-24 bg-white/10 rounded-full animate-float" style={{ animationDelay: '2s' }}></div>
      </section>

      {/* Story Section */}
      <section className="py-10 bg-white dark:bg-gray-900 transition-colors duration-300">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <motion.div 
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <h2 className="text-3xl font-bold text-gray-800 dark:text-gray-100 mb-4 text-center">
                Our Story
              </h2>
             <div className="space-y-6 text-gray-600 dark:text-gray-400 leading-relaxed text-justify">
  <p>
   YS Sky Travel and Tour Agency PLC is a trusted travel company with over five years of experience serving both local and international travelers. Based in Addis Ababa, we are committed to providing reliable, customer-focused travel services.
  </p>
  <p>
    We specialize in  <b>visa assistance, airline ticketing, and travel consultation </b> to ensure every journey starts smoothly and confidently. Our team offers clear guidance and stress-free support from start to finish.
  </p>
  <p>
    We also design customized tour packages across Ethiopia, Africa, and worldwide destinations—creating memorable travel experiences for every budget and travel style.
  </p>
</div>


              <div className="grid grid-cols-2 gap-8 mt-12">
                <div className="text-center">
                  <div className="text-4xl font-bold text-primary-600 dark:text-primary-400 mb-2">5+</div>
                  <div className="text-gray-600 dark:text-gray-400">Years Experience</div>
                </div>
                <div className="text-center">
                  <div className="text-4xl font-bold text-medical-600 dark:text-medical-400 mb-2">1000+</div>
                  <div className="text-gray-600 dark:text-gray-400">Happy Clients</div>
                </div>
              </div>
            </motion.div>

            <motion.div 
              className="relative"
              initial={{ opacity: 0, y: 40, scale: 0.95 }}
              whileInView={{ opacity: 1, y: 0, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
            >
              <video
  src={logo22}        // import your video file above
  autoPlay
  loop
  muted
  playsInline
  className="w-full h-96 object-cover rounded-2xl shadow-2xl"
></video>

              {/* <div className="absolute -bottom-8 -left-8 bg-white dark:bg-gray-800 rounded-2xl p-6 shadow-lg animate-float">
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-gradient-to-r from-primary-500 to-medical-500 rounded-full flex items-center justify-center">
                    <Award size={24} className="text-white" />
                  </div>
                  <div>
                    <div className="font-bold text-gray-900 dark:text-white">Best Clinic 2023</div>
                    <div className="text-sm text-gray-600 dark:text-gray-400">Excellence Award</div>
                  </div>
                </div>
              </div> */}
            </motion.div>
          </div>
        </div>
      </section>

    

      {/* Values Section */}
      <section className=" bg-white dark:bg-gray-900 transition-colors duration-300">
        <div className="  ">
          <motion.div 
            className="text-center mb-8"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <div className="max-w-5xl mx-auto ">
  <h2 className="text-3xl font-bold text-gray-800 dark:text-gray-100 mb-4 text-center">Our Mission & Vision</h2>
  
  <div className="grid md:grid-cols-2 gap-8">
    {/* Mission */}
    <div className="p-6 bg-white dark:bg-gray-800 rounded-lg shadow-md hover:shadow-xl transition duration-300">
      <h3 className="text-2xl font-semibold text-primary-600 mb-4">Mission</h3>
      <p className="text-gray-600 dark:text-gray-300 leading-relaxed text-justify">
        To deliver seamless, reliable, and customer-centered travel services that make every journey easier, safer, and more enjoyable. We provide trusted visa processing, airline ticketing, and personalized tour experiences that empower travelers to explore the world with confidence and comfort.
      </p>
    </div>

    {/* Vision */}
    <div className="p-6 bg-white dark:bg-gray-800 rounded-lg shadow-md hover:shadow-xl transition duration-300">
      <h3 className="text-2xl font-semibold text-primary-600 mb-4">Vision</h3>
      <p className="text-gray-600 dark:text-gray-300 leading-relaxed text-justify">
        To become one of Ethiopia’s leading travel and tour agencies—recognized for excellence, innovation, and global reach—connecting people to world-class destinations and inspiring memorable travel experiences across Ethiopia, Africa, and beyond.
      </p>
    </div>
  </div>
</div>

          </motion.div>

        
        </div>
      </section>

    </div>
  );
};

export default About;
